import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Dayjs } from "dayjs"
import styled from "styled-components"

import { useLazyGetMessageTemplatesQuery } from "store/api/contractorsApi"
import { UITypes } from "types"

import { Spinner } from "components/common/Spinner"
import { ButtonNew } from "components/form/ButtonNew"
import { SelectDynamic } from "components/form/SelectDynamic"

import MessageScheduleDateTimePicker from "../../MessageCenter/MessageScheduleDateTimePicker"

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 25px 0 18px;
  flex-wrap: wrap;
`

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

const TemplateSelectWrapper = styled.div`
  min-width: 260px;
`

const ScheduleForLaterWrapper = styled.div<{ clicked: boolean }>`
  position: relative;
  padding: 2px;
  border-radius: 25px;
  border: 2px solid ${({ clicked }) => (clicked ? "#eaeaea" : "transparent")};
`

interface Props {
  templateID: UITypes.Option[] | undefined
  setTemplateID: (value: UITypes.Option[] | undefined) => void
  onSendMessage: () => void
  onSendScheduledMessage: (dateTime: Dayjs) => void
  isSending: boolean
  onHistoryClick: () => void
}

export const CustomerDashboardMessagesHeader = ({
  templateID,
  setTemplateID,
  onSendMessage,
  onSendScheduledMessage,
  isSending,
  onHistoryClick,
}: Props) => {
  const navigate = useNavigate()
  const hasTemplate = !!templateID?.length

  const [showScheduleModal, setShowScheduleModal] = useState(false)
  const [selectedDateTime, setSelectedDateTime] = useState<Dayjs | null>(null)

  const handleCancelSchedule = () => {
    setShowScheduleModal(false)
    setSelectedDateTime(null)
  }

  const handleSubmitSchedule = () => {
    if (!selectedDateTime) return
    setShowScheduleModal(false)
    onSendScheduledMessage(selectedDateTime)
    setSelectedDateTime(null)
  }

  return (
    <Nav>
      <LeftGroup>
        <ButtonNew onClick={() => navigate("/messages/create-template")} color="blue">
          Create Template
        </ButtonNew>
        <TemplateSelectWrapper>
          <SelectDynamic
            placeholder="Select the template"
            valueName="id"
            labelName="title"
            useLazyQuery={useLazyGetMessageTemplatesQuery}
            values={templateID || []}
            onChange={setTemplateID}
          />
        </TemplateSelectWrapper>
        {hasTemplate ? (
          <>
            <ButtonNew onClick={onSendMessage} color="blue">
              {isSending ? <Spinner /> : "Send now"}
            </ButtonNew>
            <ScheduleForLaterWrapper clicked={showScheduleModal}>
              <ButtonNew color="white" onClick={() => setShowScheduleModal(true)}>
                Schedule for later
              </ButtonNew>
              {showScheduleModal && (
                <MessageScheduleDateTimePicker
                  align="right"
                  onCancel={handleCancelSchedule}
                  onSubmit={handleSubmitSchedule}
                  selectedDateTime={selectedDateTime}
                  onDateTimeChange={setSelectedDateTime}
                />
              )}
            </ScheduleForLaterWrapper>
          </>
        ) : (
          <ButtonNew disabled color="grey">
            Send now
          </ButtonNew>
        )}
      </LeftGroup>
      <ButtonNew onClick={onHistoryClick}>History</ButtonNew>
    </Nav>
  )
}
